import { render } from "./contact_view.vue?vue&type=template&id=203750d1"
const script = {}

import "./contact_view.vue?vue&type=style&index=0&id=203750d1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__